module.exports = __webpack_public_path__ + "media/campaigns/stashboards_logo_color-9c8273c2.png";